// This is based on https://www.npmjs.com/package/ng-intl-tel-input
/* The MIT License (MIT)

Copyright (c) 2015 rswebteam

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE. */
/* eslint-disable unicorn/no-abusive-eslint-disable */
/* eslint-disable */
angular.module('ngIntlTelInput', []);
angular.module('ngIntlTelInput').provider('ngIntlTelInput', function () {
  var me = this;
  var props = {};
  var setFn = function (obj) {
    if (typeof obj === 'object') {
      for (var key in obj) {
        props[key] = obj[key];
      }
    }
  };
  me.set = setFn;

  me.$get = [
    '$log',
    function ($log) {
      return Object.create(me, {
        init: {
          value: function (elm) {
            if (!window.intlTelInputUtils) {
              $log.warn(
                'intlTelInputUtils is not defined. Formatting and validation will not work.',
              );
            }
            elm.intlTelInput(props);
          },
        },
      });
    },
  ];
});
angular.module('ngIntlTelInput').directive('ngIntlTelInput', [
  'ngIntlTelInput',
  '$log',
  '$window',
  '$parse',
  function (ngIntlTelInput, $log, $window, $parse) {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function (scope, elm, attr, ctrl) {
        // Warning for bad directive usage.
        if (
          (!!attr.type && attr.type !== 'text' && attr.type !== 'tel') ||
          elm[0].tagName !== 'INPUT'
        ) {
          $log.warn(
            'ng-intl-tel-input can only be applied to a *text* or *tel* input',
          );
          return;
        }
        // Override default country.
        if (attr.initialCountry) {
          ngIntlTelInput.set({ initialCountry: attr.initialCountry });
        }
        // Initialize.
        ngIntlTelInput.init(elm);
        // Auto format number
        elm.on('keyup change', formatIntlTelInput);
        function formatIntlTelInput() {
          if (typeof intlTelInputUtils !== 'undefined') {
            // utils are lazy loaded, so must check
            var currentText = elm.intlTelInput(
              'getNumber',
              $window.intlTelInputUtils.numberFormat.E164,
            );
            if (typeof currentText === 'string') {
              // sometimes the currentText is an object :)
              elm.intlTelInput('setNumber', currentText); // will autoformat because of formatOnDisplay=true
            }
          }
        }
        // Set Selected Country Data.
        function setSelectedCountryData(model) {
          var getter = $parse(model);
          var setter = getter.assign;
          setter(scope, elm.intlTelInput('getSelectedCountryData'));
        }
        // Handle Country Changes.
        function handleCountryChange() {
          setSelectedCountryData(attr.selectedCountry);
        }
        // Country Change cleanup.
        function cleanUp() {
          angular.element($window).off('keyup change', formatIntlTelInput);
          angular.element($window).off('countrychange', handleCountryChange);
        }
        // Selected Country Data.
        if (attr.selectedCountry) {
          setSelectedCountryData(attr.selectedCountry);
          angular.element($window).on('countrychange', handleCountryChange);
          scope.$on('$destroy', cleanUp);
        }
        // Validation.
        ctrl.$validators.ngIntlTelInput = function (value) {
          // if phone number is deleted / empty do not run phone number validation
          if (value || elm[0].value.length > 0) {
            return elm.intlTelInput('isValidNumber');
          } else {
            return true;
          }
        };
        // Set model value to valid, formatted version.
        ctrl.$parsers.push((value) => {
          return elm.intlTelInput('getNumber');
        });
        // Set input value to model value and trigger evaluation.
        ctrl.$formatters.push((value) => {
          if (value) {
            if (value.charAt(0) !== '+') {
              value = '+' + value;
            }
            elm.intlTelInput('setNumber', value);
          }
          return value;
        });
      },
    };
  },
]);
/* eslint-enable */
